module.exports = __webpack_public_path__ + "static/media/ingles.c7f85a75.png";